<div *ngIf="signalType$ | async as signalType">
    Signal Type : <span style="color: gray; font-weight: bold;"> {{signalType.key}} </span>
</div>
<div *ngIf="units$ | async as unite">
    Unite : <span style="color: gray; font-weight: bold;"> {{unite.key}} </span>
    <br>
    Identifier :<span style="color: gray; font-weight: bold;"> {{unite.identifier}} </span>
</div>